export default __webpack_public_path__ + "static/media/dtt-background-large.1a3620ec.jpg";